import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import * as moment from 'moment'
import { ShowpoiroutePage } from '../showpoiroute/showpoiroute';
//import { ProgressroutesPage } from '../progressroutes/progressroutes';
// import { HomePage } from '../home/home';
// import { GlobalPage } from '../global/global';

/**
 * Generated class for the ChatsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-chats',
  templateUrl: 'chats.html',
})
export class ChatsPage {

  messobj: any
  _message = ''
  // cb: any
  loadingData: boolean = true
  chathistory = []
  readed = []
  addpoimap: any
  lat: any
  lon: any
  poiname: any
  url: any
  buttonMultipleCLicks = false

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public modalCtrl: ModalController) {
    this.messobj = navParams.get('message')
    console.log(this.messobj, ' this.messobj')
    this.addpoimap = navParams.get('addpoimap')
    if (this.addpoimap == 1) {
      this.lat = navParams.get('lat')
      this.lon = navParams.get('lon')
      this.poiname = navParams.get('poiname')
      this._message = this.poiname + ': ' + this.lat + ', ' + this.lon
    }



    // this.cb = navParams.get('cb');
    // console.log(this.lat, this.lon, this.poiname, 'daj da vidime')

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatsPage');
    this.loadData()
    var _that = this
    this.gn.reloadCHatFunction = function () {
      _that.loadData()
    }
  }

  ionViewDidLeave() {
    this.gn.reloadCHatFunction = null
  }


  setFoxus() {
    // var imp = (<HTMLInputElement>document.getElementById('myInput').getElementsByTagName('INPUT')[0]).focus()
    //imp.getElementsByTagName('INPUT')[0].focus()
  }
  sendImpulse() {
    ///api/reloadchat
    this.gn._Post('/api/reloadchat', { cid: this.gn.crypt(this.gn.user.ClientId), fid: this.gn.crypt(this.gn.user.UserId), tid: this.gn.crypt(this.messobj.id) }, function (_data) { })
  }
  markAsReaded(_ids) {
    var _that = this
    this.gn._Post('/api/gn/markasread', { ids: this.gn.crypt(_ids) }, function (_data) {
      _that.sendImpulse()
    })
  }

  copy(that) {
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = that
    inp.select();
    document.execCommand('copy', false);
    inp.remove();
  }

  showPoiRoute(ch) {
    var _that = this
    let modal = this.modalCtrl.create(ShowpoiroutePage, {
      obj: ch, cb: function () {
        //_that.loadData()
      }
    },
      { cssClass: "modal-fullscreencomm" }
    );
    modal.present();
  }

  loadData() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getMessages', { fromuid: this.gn.crypt(this.gn.user.UserId), touid: this.gn.crypt(this.messobj.id) }, function (_data) {
      _that.readed = []
      for (let i = 0; i < _data.length; i++) {
        _data[i].tim = moment(_data[i].dtcreate).format('HH:mm')
        _data[i].dat = moment(_data[i].dtcreate).format('D MMM YYYY')
        _data[i].tip = 0
        if (_data[i].message.indexOf('@REQUEST@') == 0) {
          var arr = _data[i].message.split('@')
          if (arr[6] + '' != '-1')
            _data[i].message = _that.dic.l["thedriver"] + ' [' + arr[4] + '] ' + _that.dic.l["wantsuse"] + ' [' + arr[8] + ']. ' + _that.dic.l["alreadyused"] + ' [' + arr[6] + ']. ' + _that.dic.l["approve"]
          else
            _data[i].message = _that.dic.l["thedriver"] + ' [' + arr[4] + '] ' + _that.dic.l["wantsuse"] + ' [' + arr[8] + ']. ' + _that.dic.l["approve"]

          _data[i].omessage = '@' + arr.join('@')
          _data[i].tip = 1
        }

        if (_data[i].message.indexOf('#POIROUTE#') != -1) {
          var arr = _data[i].message.split('#')
          _data[i].message = _that.dic.l["locateVisit"] + ': ' + arr[2] + ' (' + arr[3] + ')'
          _data[i].loc = arr[2]
          _data[i].tip = 2
          _data[i].ll = arr[3]

          var _lon = 21.427379;
          var _lat = 41.998802;
          _data[i].url = '/'
          for (var v = 0; v < _that.gn.Vehicles.length; v++) {
            var tf = false;
            if (_that.gn.Vehicles[v].driver + '' == _that.gn.user.UserFullName + '') {
              _lon = parseFloat(_that.gn.Vehicles[v].lon)
              _lat = parseFloat(_that.gn.Vehicles[v].lat)
              _data[i].url = "https://www.google.com/maps/dir/" + _lat + "," + _lon + "/" + arr[3].split(', ')[0] + "," + arr[3].split(', ')[1] + "/data=!3m1!4b1!4m2!4m1!3e0"
            }
          }
        }

        // debugger
        if (_data[i].message.indexOf('#BANK#') != -1) {
          var arrRoute = _data[i].message.split('#')
          // debugger
          if (_data[i].message.indexOf('&nov&') != -1 || _data[i].message.indexOf('&promeni&') != -1) {
            var PromenaIliDodadeNalog = arrRoute[2].split('&')
            var tipruta = ''
            if (PromenaIliDodadeNalog[1] == 'nov') {
              tipruta = _that.dic.l["new"]
            }
            if (PromenaIliDodadeNalog[1] == 'promeni') {
              tipruta = _that.dic.l["changed1"]
            }
            _data[i].message = _that.dic.l["youHave"] + ' ' + tipruta + ' ' + _that.dic.l["route"] + ': ' + ' ' + PromenaIliDodadeNalog[0]
          }
          else {
            _data[i].message = _that.dic.l["youhavenewroute"] + ' ' + ' ' + arrRoute[2]
          }
          _data[i].tip = 3
        }

        if (_data[i].message.indexOf('#routetodriver#') != -1) {
          var arrRoute = _data[i].message.split('#')
          // debugger

          _data[i].message = _that.dic.l["youhavenewroute"] + ' ' + arrRoute[2]

          _data[i].tip = 4

        }

        if (_data[i].touserid == _that.gn.user.UserId && _data[i].fromuserid != _that.gn.user.UserId) {
          if (_data[i].read + '' == '0') {
            _that.readed.push(_data[i].id + '')
          }
        }
        if (_that.readed.length > 0) {
          _that.markAsReaded(_that.readed.join(','))
        }
      }
      _that.chathistory = _data
      // console.log(_that.chathistory, 'daj mi _that.chathistory')
      setTimeout(function () {
        _that.scrollToBottom()
      }, 50)
      _that.loadingData = false

    })

  }


  routeNavigate(_ch) {
    var idNum = _ch.id
    //debugger
    this.buttonMultipleCLicks = true

    // ova e problematika za message i za vlez

    var delroutechangedbank = 0
    var rnalogidText = -1
    var _fromuserid = -1
    var _touserid = -1
    if (_ch.message.indexOf(this.dic.l["changed1"]) != -1) {
      delroutechangedbank = 1
      var arr = _ch.message.split(' ')
      rnalogidText = parseInt(arr[arr.length - 1] + '')
      _fromuserid = _ch.fromuserid
      _touserid = _ch.touserid
    }



    var _that = this
    var _mesg = '** ' + _that.dic.l["sysmess01"] + ' ' + _that.gn.user.UserFullName + ' **'
    console.log(_ch.id, '_ch.id')
    this.gn._Post('/api/gn/deletefromchat', {
      cid: this.gn.crypt(idNum),
      isroutechanged: this.gn.crypt(delroutechangedbank),
      nalogid: this.gn.crypt(rnalogidText),
      fromuserid: this.gn.crypt(_fromuserid),
      touserid: this.gn.crypt(_touserid)
    }, function (_dat2) {
      _that.removeChatFromList(idNum)
      // var dat = {
      //   fromuid: _that.gn.crypt(_that.gn.user.UserId),
      //   touid: _that.gn.crypt(_that.messobj.id),
      //   message: _that.gn.crypt(_mesg),
      // }
      _that.buttonMultipleCLicks = false

      _that._send(_mesg)

      // _that.gn._Post('/api/gn/createMessage', dat, function (_data) {
      //   console.log(_data, 'daj da vidam data')
      //   // if (document.getElementById('mob-footer') != null && document.getElementById('mob-footer').offsetHeight > 0) {
      //   //   console.log('MOBILEN')
      //   //   _that.navCtrl.setRoot(GlobalPage, { key: 'routingmob' });
      //   //   _that.navCtrl.popToRoot();
      //   // } else {
      //   //   console.log('DESKTOP')
      //   //   _that.navCtrl.setRoot(GlobalPage, { key: 'routing' });
      //   //   _that.navCtrl.popToRoot();

      //   // }
      //   _data[0].tim = moment(_data[0].dtcreate).format('HH:mm')
      //   _data[0].dat = moment(_data[0].dtcreate).format('D MMM YYYY')
      //   // _that.navCtrl.pop();
      //   //_that.gn.enableBtn();
      //   _that.chathistory.push(_data[0])
      //   _that.sendImpulse()
      // })
    })


    //   debugger



    // this.navCtrl.setRoot(GlobalPage, { key: 'routingmob' });
    // this.navCtrl.popToRoot();
  }

  sendenter(ev: any) {
    ev = this.send()
    this._message = ''


  }

  send() {
    this._send(this._message)
  }
  _send(_mesg) {
    if (this.buttonMultipleCLicks || this._message == '') return false;

    this.buttonMultipleCLicks = true

    var LLdestionation = this.lat + '@' + this.lon
    var messhulk = '#POIROUTE#' + this.poiname + '#' + this.lat + ', ' + this.lon
    var _that = this;


    //prakanje poi na sofer za ruta
    var dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      fromuid: this.gn.crypt(this.gn.user.UserId),
      touid: this.gn.crypt(this.messobj.id),
      message: (this.addpoimap == 1) ? this.gn.crypt(messhulk) : this.gn.crypt(_mesg),
      ifaddpoimap: this.gn.crypt(this.addpoimap),
      vehicleid: (this.addpoimap == 1) ? this.gn.crypt(this.messobj.vehicleid) : -1,
      poiname: (this.addpoimap == 1) ? this.gn.crypt(this.poiname) : '',
      lldest: (this.addpoimap == 1) ? this.gn.crypt(LLdestionation) : '',
      info: (this.messobj.garmin == 1) ? this.gn.crypt('1') : this.gn.crypt('0'),
      vehgsm: (this.messobj.garmin == 1) ? this.gn.crypt(this.gn.Vehicles[this.gn.VehiclesDic[this.messobj.id]].gsmnum) : this.gn.crypt('-1'),
      direct: (this.messobj.garmin == 1) ? (this.messobj.direct ? this.gn.crypt('1') : this.gn.crypt('0')) : this.gn.crypt('-1')
    }

    // this._message = '#POIROUTE#' + this.poiname + '#' + this.lat + ', ' + this.lon


    //this.gn.disableBtn();
    var _that = this
    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/createMessage', dat, function (_data) {
      if (_that.addpoimap == 1) {
        var messhulk = '#POIROUTE#' + _that.poiname + '#' + _that.lat + ', ' + _that.lon
        if (messhulk.indexOf('#POIROUTE#') != -1) {
          var arr = messhulk.split('#')
          _data[0].message = _that.dic.l["locateVisit"] + ': ' + arr[2] + ' (' + arr[3] + ')'
        }
      }
      if (_that.messobj.garmin == 1) {
        //debugger
        // var messhulk = '#POIROUTE#' + _that.poiname + '#' + _that.lat + ', ' + _that.lon
        // if (messhulk.indexOf('#POIROUTE#') != -1) {
        //   var arr = messhulk.split('#')
        //   _data[0].message = _that.dic.l["locateVisit"] + ': ' + arr[2] + ' (' + arr[3] + ')'
        // }
      }
      _data[0].tim = moment(_data[0].dtcreate).format('HH:mm')
      _data[0].dat = moment(_data[0].dtcreate).format('D MMM YYYY')
      // _that.navCtrl.pop();
      //_that.gn.enableBtn();
      _that.chathistory.push(_data[0])
      _that.gn.tfBtn = false;
      _that._message = ''
      _that.sendImpulse()
      setTimeout(function () {
        _that.scrollToBottom()
        _that.addpoimap = 0;

        _that.buttonMultipleCLicks = false

      }, 50)
    })
    var objel = (<HTMLInputElement>document.getElementById('myInput').getElementsByTagName('INPUT')[0])
    objel.focus()

  }

  scrollToBottom() {
    var obj = document.getElementById('chatHistory')
    if (obj != null) {
      var _h = obj.parentElement.scrollHeight
      obj.parentElement.scrollTop = _h
    }

  }


  removeChatFromList(_id) {
    console.log(_id, 'daj da vidam id sto se desava')
    var idx = -1
    for (var i = 0; i < this.chathistory.length; i++) {
      if (this.chathistory[i].id + '' == _id + '') {
        idx = i
      }
    }
    if (idx > -1) {
      this.chathistory.splice(idx, 1)
    }
  }
  odobruvam(_ch) {
    this.buttonMultipleCLicks = true
    var arr = _ch.omessage.split('@')
    var soferid = arr[3]
    var vehicleid = arr[8]
    var _that = this
    // pod uslov da e od addpoimap za long i lat
    // ifaddpoimap: this.gn.crypt(this.addpoimap),
    // lat: this.gn.crypt(this.lat),
    // lon: this.gn.crypt(this.lon),
    // poiname: this.gn.crypt(this.poiname),
    var latandlong = this.lat + '|' + this.lon
    this.gn._Post('/api/gn/confirmreassignadmin', {
      did: this.gn.crypt(soferid),
      vid: this.gn.crypt(vehicleid),
      dest: this.gn.crypt(arr[11]),
      // destLL: this.gn.crypt(latandlong), 
      // destPoiName: this.gn.crypt(this.poiname), 
      // ifaddpoimap: this.gn.crypt(this.addpoimap),
      touid: this.gn.crypt(this.messobj.id)
    }, function (_dat1) {
      _that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driver = _dat1.data[0].drivername
      _that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest = _dat1.data[0].location

      if (_that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest != '/') {
        _that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest = _that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest.split('@')[0]
        if (_that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest == '') {
          _that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest = _that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest.split('@')[1] + ', ' + _that.gn.Vehicles[_that.gn.VehiclesDic[vehicleid]].driverdest.split('@')[2]
        }
      }

      _that.gn._Post('/api/gn/deletefromchat', { cid: _that.gn.crypt(_ch.id) }, function (_dat2) {
        _that.removeChatFromList(_ch.id)
        _that.buttonMultipleCLicks = false
        _that._send('** ' + _that.dic.l["sysmess02"] + ' [' + arr[9] + '] ' + _that.dic.l["sysmess03"] + ' **')
      })
    })
  }
  neodobruvam(_ch) {
    this.buttonMultipleCLicks = true
    var arr = _ch.omessage.split('@')
    // var chatid = _ch.id
    var _that = this
    this.gn._Post('/api/gn/deletefromchat', { cid: this.gn.crypt(_ch.id) }, function (_dat2) {
      _that.removeChatFromList(_ch.id)
      _that.buttonMultipleCLicks = false
      _that._send('** ' + _that.dic.l["sysmess02"] + ' [' + arr[9] + '] ' + _that.dic.l["sysmess04"] + ' **')
    })

    // /api/gn/deletefromchat
  }

  garmin() {
    this.messobj.direct = !this.messobj.direct;
  }

}



// WEBPACK FOOTER //
// ./src/pages/messages/chats.ts